import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
//import NavDropdown from 'react-bootstrap/NavDropdown';
import LoginButton from "./LoginButton";
import LogoutButton from "./LogoutButton";
import Login_Profile from "./Login_Profile";
import { Container  } from 'react-bootstrap';
import { useLocation } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
const { Controlla_se_lavoro_in_debug } = require('../Funzioni_comuni_3')


function check_variabili_oggetto(obj, ...args) {
  return args.reduce((obj, level) => obj && obj[level], obj)
}


function NavScrollExample(props) {

  const [pageURL, setPageURL] = useState(0);
  const [disabilita, SET_disabilita] = useState(false);
  const { user, isAuthenticated } = useAuth0();
  const [debug, SET_debug] = useState(false);
  

  useEffect(() => {
    console.log('+++++ USEEFFECT +++++')
    console.log('il bottone salva [ stato premuto')
     
    if (Controlla_se_lavoro_in_debug(user)) {
      SET_debug(true)
    }
    //        setTimeout(() => {
    //            setAlert(false);
    //        }, 3000);
    //        let history = useHistory();

// controlla se l-ingresso avviene da una mail esterna    
    setPageURL(window.location.href);
    if (window.location.href.includes("url")) {
       SET_disabilita(true)
    } 
  }, [user]);


    const search = useLocation().search;
    console.log(search)
    console.log(window.location.href)
    

// aggiorna lo stato quando con il checkbox vado in debug    
    function handleChange(event) {
    //    console.log(event.target)
        const { name, value, type } = event.target;
        console.log('cc5' + name + event.target.checked)
        if (name === "utente_debug") {
    //        dispatch(assegna_debug_redux(event.target.checked))
    //       console.log('ENTRST cc5' + name + event.target.checked)
    
            let updatedValue = {};
               /* idroslab */
     
            updatedValue = {"utente_debug": event.target.checked};
            props.SET_account_dati(prevInput => ({
                ...prevInput,
                ...updatedValue
        }))
    }
  }


  return (
    <Navbar bg="light" expand="lg">
      <Container fluid>
            <Navbar.Brand href="#">IPSIA Gestione PCTO</Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarScroll" />
            <Navbar.Collapse id="navbarScroll">
            <Nav
                className="me-auto my-2 my-lg-0"
                style={{ maxHeight: '100px' }}
                navbarScroll
            >
            {debug &&  <>
            
              <Nav.Link href="#/url_tutor">Tutor</Nav.Link>
              <Nav.Link href="#/url_classi">Classi</Nav.Link>
              </>
            }
            <Nav.Link href="#/url_alunno">Alunni</Nav.Link>
            <Nav.Link href="#/url_ditte">Ditta</Nav.Link>
            <Nav.Link href="#/url_progetti">Progetto</Nav.Link>
            <Nav.Link href="#/url_qrcode">Upload PDF</Nav.Link>

            <Nav.Link href="#/url_google_maps">Mappa</Nav.Link>

            {debug &&  <Nav.Link href="#/url_prova_codice">Prova_codice NEW</Nav.Link>}
            </Nav>

            {debug &&
              <div>       
                <input  name="utente_debug" 
                type="checkbox" 
                defaultChecked={props.account_dati.utente_debug}
                value={props.account_dati.utente_debug}
                onChange={handleChange}
                />
                <label class="form-check-label" for="flexCheckChecked">
                    Show Debug {'  '} 
                </label>
            </div>
            }      


            <LoginButton/> 
       
            <LogoutButton/> 
            <Login_Profile/> 
           
            
            
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavScrollExample;